import React from "react";

export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Outros Serviços</h2>
          <p>
            Nossa rede de parcerias abrange múltiplas especialidades em tecnologia da informação, garantindo soluções completas e inovadoras para atender às necessidades específicas de cada cliente. Comprometidos com a excelência, colaboramos com os melhores do setor para entregar resultados que impulsionam o sucesso empresarial.
          </p>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
              <div key={`${d.name}-${i}`} className="col-md-4">
                {" "}
                <i className={d.icon}></i>
                <div className="service-desc">
                  <h3>{d.name}</h3>
                  <p>{d.text}</p>
                </div>
              </div>
            ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
